import index from './index.vue';
import indexAz from './index-az.vue';
import { ApartmentForm, CallTypeListData } from './all.type';

export default SERVER_LOCATION === 'az' ? indexAz : index;
export {
    ApartmentForm
};